import { isNullOrUndefined } from 'util';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
// import Swal from 'sweetalert2';
import { UserManagementService } from 'src/app/services/user-management.service';
import { EncdecService } from 'src/app/services/encdec.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';

@Component({
  selector: 'app-profile-login',
  templateUrl: './profile-login.component.html',
  styleUrls: ['./profile-login.component.css']
})
export class ProfileLoginComponent implements OnInit {
  passwordForm: FormGroup = this.fb.group({
    currentPassword: new FormControl(null, [Validators.required]),
    newPassword: new FormControl(null, [Validators.required]),
    confirmNewPassword: new FormControl(null, [Validators.required]),
  })
  passwordtext :any;
  showerrorpwd : any;
  showerrorcnpwd : any;
  UserData : object = {password:'',confirmpassword:''};
  profileData :object = {name :'',email:'',mobilenum:''}
  showError: boolean = false;
  context: string = 'Submit';
  
  constructor(
    private userService: UserManagementService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private modal: NgbActiveModal,
    private toastrService: ToastrService,
    private encdecservice : EncdecService,
    private constant : ConstantsModule,
    private authservice : AuthloginService,
    private submitdataservice : SubmitdataService,
  ) { }

  ngOnInit() {
    this.passwordtext = this.constant.PASSWORD_STANDARD;
  }

  getCtrl(ctrlName) {
    return !isNullOrUndefined(this.passwordForm.controls[ctrlName]) ? this.passwordForm.controls[ctrlName] : null;
  }

  hasError(ctrlName) {
    return (this.getCtrl(ctrlName).touched || this.getCtrl(ctrlName).dirty) && !isNullOrUndefined(this.getCtrl(ctrlName).errors);
  }

  handleChangePassword() {
    this.showError = true;
    if (this.passwordForm.valid) {
      let temp = this.passwordForm.value;
      let passwordHash  = this.encdecservice.rsaenc(this.constant.PUBLIC_KEY,temp.currentPassword+","+temp.newPassword);
      let newPassword = temp.newPassword;
      let confirmNewPassword = temp.confirmNewPassword;
      console.log(passwordHash)
      if(newPassword == confirmNewPassword){
        let postdata = {
          passwordHash
        }
        this.userService.changePassword(postdata.passwordHash).subscribe((res: any) => {
          if (res.result.success) {
            // Swal.fire('Success...', res.result.content, 'success');
            this.modal.close();
          } else {
            if(res.result.status != 406 || res.result.status != 420){
            // Swal.fire('Failure...',res.result.content, 'error');
            } if(res.result.status == 420){
              this.authservice.logoutuserandsessionclear();
            }
          }
        }, (err) => {
          // Swal.fire('Failure...', err.message, 'error');
        })
        return;
      }else {
        // Swal.fire('Failure...', "New Password and Confirm New Password should be same", 'error');
      }
    }
  }

  public pswdValidate(pswd,str){
    let passw = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,20}$/
      if(pswd.match(passw)) 
      { 
        str == 'password' ? this.showerrorpwd = false : this.showerrorcnpwd = false;
      } else{
        str == 'password' ? this.showerrorpwd = true : this.showerrorcnpwd = true;
      }
  }

  resetValues() {
    this.passwordForm.reset();
  }

  closeModal() {
    this.modal.dismiss();
  }
  getprofileFormData(){
    let postdata = {};
    postdata['name'] = this.profileData['name'];
    postdata['email'] = this.profileData['email'];
    postdata['mobilenum'] = this.profileData['mobilenum'];
    this.submitdataservice.profileFormSubmit(postdata).subscribe(data =>{
      
    })
  }
}
